import { useCallback, useMemo, useState } from 'react';

import {
  formatTime,
  getCalendarPixelsPerMinute,
  getCurrentMinutes,
  toMinutes,
} from '@pages/Calendar/utils';

import { HEADER_HEIGHT } from '@pages/Calendar/data';

import { useCurrentTimeLineEffects } from './useCurrentTimeLineEffects';

interface UseCurrentTimeLineProps {
  startTime: string;
  isToday: boolean;
  intervalHeightPx: number;
}

export const useCurrentTimeLine = ({
  startTime,
  isToday,
  intervalHeightPx,
}: UseCurrentTimeLineProps) => {
  const [currentMinutes, setCurrentMinutes] = useState(getCurrentMinutes);

  const updateTimeHandler = useCallback(() => {
    setCurrentMinutes(getCurrentMinutes());
  }, []);

  useCurrentTimeLineEffects({ isToday, updateTimeHandler });

  const startMinutes = useMemo(() => toMinutes(startTime), [startTime]);

  const topPx = useMemo(
    () =>
      HEADER_HEIGHT +
      (currentMinutes - startMinutes) *
        getCalendarPixelsPerMinute(intervalHeightPx),
    [currentMinutes, intervalHeightPx, startMinutes]
  );

  const currentTimeLabel = useMemo(
    () => formatTime(currentMinutes),
    [currentMinutes]
  );

  return {
    topPx,
    currentTimeLabel,
  };
};
